"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectProperties = void 0;
exports.projectProperties = {
    projectTypes: {
        taskpane: {
            displayname: "core.newTaskpaneAddin.label",
            detail: "core.newTaskpaneAddin.detail",
            manifestPath: "manifest.json",
            templates: {
                typescript: {
                    repository: "https://github.com/OfficeDev/Office-Addin-TaskPane",
                    branch: "json-preview-yo-office",
                    prerelease: "json-preview-yo-office-prerelease",
                },
            },
            supportedHosts: ["Outlook"],
        },
    },
    hostTypes: {
        excel: {
            displayname: "Excel",
        },
        onenote: {
            displayname: "OneNote",
        },
        outlook: {
            displayname: "Outlook",
        },
        powerpoint: {
            displayname: "PowerPoint",
        },
        project: {
            displayname: "Project",
        },
        word: {
            displayname: "Word",
        },
    },
};
//# sourceMappingURL=projectProperties.js.map